import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchValidatedMultDataTypes = getApiActionTypes(
  'DATA_COLLECTION/FETCH_VALIDATED_ACCOUNT_DATA',
);
export const uploadMultDataTypes = getApiActionTypes('DATA_COLLECTION/UPLOAD_ACCOUNT_DATA');
export const RESET_VALIDATED_MULT_DATA = 'DATA_COLLECTION/RESET_VALIDATED_ACCOUNT_DATA';
